import { Link } from 'react-router-dom';

const guides = [
  {
    title: 'Superbuy Spreadsheet 2026: Complete Beginner Guide',
    description: 'Everything you need to know about using Superbuy Spreadsheet to discover products faster and shop smarter.',
    tag: 'Beginner Guide',
    link: '/superbuy-spreadsheet-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Open%20leather%20notebook%20with%20beautiful%20product%20photography%20prints%20spread%20across%20cream%20pages%2C%20coffee%20cup%20and%20reading%20glasses%20nearby%2C%20warm%20afternoon%20sunlight%20streaming%20from%20window%2C%20top%20down%20flat%20lay%2C%20editorial%20lifestyle%20photography%2C%20warm%20neutral%20tones%2C%20cozy%20organized%20atmosphere%2C%20soft%20shadows&width=600&height=400&seq=guide-card-beginner-v2&orientation=landscape',
  },
  {
    title: 'Superbuy Spreadsheet Product Comparison Guide',
    description: 'Learn how to compare products across categories and make informed purchasing decisions with our comparison tools.',
    tag: 'Comparison',
    link: '/superbuy-spreadsheet-comparison',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20brass%20magnifying%20glass%20resting%20on%20a%20product%20specification%20card%20with%20fashion%20item%20photo%2C%20clean%20cream%20desk%20surface%2C%20soft%20natural%20morning%20light%2C%20minimal%20editorial%20style%2C%20warm%20beige%20and%20brass%20accents%2C%20product%20evaluation%20concept%2C%20sophisticated%20photography%2C%20gentle%20shadows&width=600&height=400&seq=guide-card-compare-v2&orientation=landscape',
  },
  {
    title: 'Superbuy Spreadsheet Safety & Trust Center',
    description: 'Understand our commitment to providing reliable, verified product information and maintaining a trustworthy platform.',
    tag: 'Safety',
    link: '/superbuy-spreadsheet-safety',
    imageUrl: 'https://readdy.ai/api/search-image?query=Transparent%20glass%20display%20dome%20protecting%20a%20single%20elegant%20product%20on%20pedestal%2C%20soft%20diffused%20studio%20lighting%2C%20warm%20cream%20background%2C%20museum%20quality%20presentation%2C%20security%20and%20trust%20concept%2C%20minimal%20editorial%20photography%2C%20clean%20premium%20aesthetic%2C%20gentle%20highlights%20and%20soft%20shadows&width=600&height=400&seq=guide-card-safety-v2&orientation=landscape',
  },
  {
    title: 'Superbuy Spreadsheet Category Database Overview',
    description: 'Browse our complete category database spanning 14 curated collections from shoes to accessories and beyond.',
    tag: 'Database',
    link: '/superbuy-spreadsheet-database',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20tabbed%20category%20dividers%20arranged%20in%20a%20row%20on%20warm%20cream%20surface%2C%20each%20tab%20labeled%20with%20different%20fashion%20item%20sketches%2C%20top%20down%20editorial%20photography%2C%20soft%20natural%20light%2C%20warm%20neutral%20palette%20with%20subtle%20accent%20colors%2C%20organized%20catalog%20concept%2C%20clean%20composition&width=600&height=400&seq=guide-card-database-v2&orientation=landscape',
  },
];

export default function KnowledgeHub() {
  return (
    <section id="guides" className="w-full bg-foreground-950 py-16 md:py-24 px-4 md:px-8 lg:px-14">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6 mb-14">
          <span className="inline-block px-5 py-2 border border-background-50/20 rounded-full text-xs font-label font-medium text-background-50/80 bg-transparent whitespace-nowrap w-fit">
            Latest Guides
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight tracking-tight lg:text-right lg:max-w-lg">
            Knowledge Hub
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {guides.map((guide) => {
            const cardContent = (
              <div className="group cursor-pointer">
                <div className="relative overflow-hidden rounded-lg aspect-[3/2] mb-4">
                  <img
                    src={guide.imageUrl}
                    alt={guide.title}
                    title={guide.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-3 py-1 bg-background-50/90 text-foreground-950 text-xs font-label font-medium rounded-full whitespace-nowrap">
                      {guide.tag}
                    </span>
                  </div>
                </div>
                <h3 className="text-base font-heading font-semibold text-background-50 mb-2 leading-snug group-hover:text-background-100 transition-colors">
                  {guide.title}
                </h3>
                <p className="text-xs text-background-50/50 leading-relaxed">{guide.description}</p>
              </div>
            );

            return (
              <Link key={guide.title} to={guide.link} className="block">
                {cardContent}
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}